<template>
  <div class="onboarding-date-component-container">
    <div class="heading">
      <div>Welcome, {{ $store.getters['session/currentUser'].firstName }}!</div>
      {{ explanation }}
    </div>
    <div class="card">
      <template v-if="type">
        <div class="title">
          {{ question }}
        </div>
        <div class="selects">
          <select v-model="month">
            <option
              disabled
              value="0"
            >
              Month
            </option>
            <template v-for="(m, index) in months">
              <option
                :key="index"
                :value="index + 1"
              >
                {{ m }}
              </option>
            </template>
          </select>
          <select v-model="year">
            <option
              disabled
              value="0"
            >
              Year
            </option>
            <template v-for="(y, index) in years">
              <option
                :key="index"
                :value="y"
              >
                {{ y }}
              </option>
            </template>
          </select>
        </div>
        <button
          :class="{ disabled: !dateEntered }"
          @click="submit()"
        >
          Submit
        </button>
      </template>
      <template v-else>
        <div class="title">
          Have you graduated?
        </div>
        <div class="choices">
          <div @click="setType('graduation')">
            No
          </div>
          <div @click="setType('test')">
            Yes
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { shouldAskGraduation, shouldEnterOnboarding } from '@/utils/onboarding';
import GlobalMixin from '@/mixins/global';

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      month: 0,
      type: null,
      year: 0,
    };
  },
  computed: {
    dateEntered() {
      return this.month > 0 && this.year > 0;
    },
    explanation() {
      if (shouldAskGraduation(this.$store)) {
        return 'Please answer these two questions to begin your study experience.';
      } else {
        return 'Please answer this one question to begin your study experience.';
      }
    },
    key() {
      if (this.type === 'graduation') {
        return 'expectedGraduationDate';
      } else if (this.type === 'test') {
        return 'estimatedTestDate';
      }
    },
    question() {
      if (this.type === 'graduation') {
        return 'When do you graduate?';
      } else if (this.type === 'test') {
        if (shouldAskGraduation(this.$store)) {
          return 'Congratulations! When are you taking your exam?';
        } else {
          return 'When are you taking your exam?';
        }
      }
    },
  },
  created() {
    this.$analytics.events.viewedGraduationStatus();
    if (!shouldEnterOnboarding(this.$store)) {
      this.$router.push({ name: 'home' });
    } else if (!shouldAskGraduation(this.$store)) {
      this.setType('test');
    }
  },
  methods: {
    setType(type) {
      this.type = type;
      this.$analytics.events.selectedGraduationStatus(type);
      this.$analytics.events.viewedGraduationDate();
    },
    submit() {
      if (this.dateEntered) {
        // Jan = 0 in months for JS
        const date = new Date(this.year, this.month - 1);
        const params = {};
        params[this.key] = date.getTime();
        this.$store.dispatch('session/updateUser', params).then(() => {
          this.$router.push({ name: 'home' });
          this.$analytics.events.savedGraduationDate();
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .onboarding-date-component-container {
    background: #f1f4f8;
    color: #354052;
    text-align: center;

    .heading {
      font-size: rem-calc(18);

      > div {
        font-size: rem-calc(32);
        font-weight: $semi-bold;
        margin: rem-calc(64) 0 rem-calc(16) 0;
      }
    }

    .card {
      background: white;
      border-radius: 8px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
      margin: rem-calc(36) auto 0 auto;
      padding: rem-calc(32);
      width: rem-calc(320);

      .title {
        font-size: rem-calc(24);
        font-weight: $semi-bold;
      }

      .choices {
        display: flex;
        justify-content: center;
        margin-top: rem-calc(24);

        > div {
          border: solid 1px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          background: #4fb9de;
          color: white;
          cursor: pointer;
          font-size: rem-calc(18);
          font-weight: $semi-bold;
          padding: rem-calc(12) 0;
          width: rem-calc(96);

          &:first-child {
            margin-right: rem-calc(12);
          }

          &:last-child {
            margin-left: rem-calc(12);
          }
        }
      }

      .selects {
        margin: rem-calc(16) 0;

        select {
          @include select-base;
          border-bottom: 1px solid #e2e7ee;
          border-radius: 0;
          font-size: rem-calc(14);
          font-weight: $semi-bold;
          margin: rem-calc(8);
          padding: rem-calc(6) rem-calc(8);
          width: rem-calc(100);
        }
      }

      button {
        background: #7bd56e;
        border: solid 1px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        color: white;
        font-weight: $semi-bold;
        padding: rem-calc(12);
        width: rem-calc(216);


        &.disabled {
          opacity: 0.6;
          pointer-events: none;
        }
      }
    }
  }
</style>
